import React from 'react'
//import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
  //CAvatar,
  //CButton,
  //CButtonGroup,
  CCard,
  CCardBody,
  //CCardImage,
  //CCardTitle,
  CCardText,
  //CCardFooter,
  //CCardHeader,
  CCol,
  //CProgress,
  CRow,
  //CTable,
  //CFormSwitch,
  CImage,
  CFormCheck,
  CContainer,
} from '@coreui/react'
//import apiClient from '../../services/apiClient'
//import { getStyle } from '@coreui/utils'
//import { CChartBar, CChartLine } from '@coreui/react-chartjs'
//import CIcon from '@coreui/icons-react'
//import { cilArrowBottom, cilArrowTop, cilOptions } from '@coreui/icons'
//import { useNavigate } from 'react-router-dom'
import devicePic4 from 'src/assets/images/membership.jpeg'

const WidgetsReminderMembership = () => {
  //let navigate = useNavigate()

  const handleFREEMembership = async () => {
    localStorage.setItem('membership', '1')
    console.log('FREE MEMBERSHIP')
  }

  const handlePREMIUMMembership = async () => {
    localStorage.setItem('membership', '2')
    console.log('PREMIUM MEMBERSHIP')
  }

  const handleVIPMembership = async () => {
    localStorage.setItem('membership', '3')
    console.log('VIP MEMBERSHIP')
  }

  return (
    <div className="small text-medium-emphasis">
      <div className="small text-medium-emphasis">
        <CCard key={1}>
          {/*<CCard key={recommendation.id}>*/}
          <CCardBody>
            <CCol>
              <CCardText>{'MEMBERSHIP SELECTION'}</CCardText>
              <CContainer>
                <CRow xs={{ cols: 2, gutter: 2 }} lg={{ cols: 4, gutter: 3 }}>
                  <CCol>
                    <div className="p-3">
                      <CImage rounded orientation="top" src={devicePic4} width={150} height={150} />
                    </div>
                  </CCol>
                  <CCol>
                    <div className="p-3">
                      <CFormCheck
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        label="FREE MEMBERSHIP"
                        onChange={handleFREEMembership}
                      />
                      <p> PRICE:</p>
                      <p> - yearly price 0 EUR/month</p>
                      <p> FUNCTIONS:</p>
                      <p> - Care about your house</p>
                    </div>
                  </CCol>
                  <CCol>
                    <div className="p-3">
                      <CFormCheck
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        label="PREMIUM MEMBERSHIP"
                        onChange={handlePREMIUMMembership}
                      />
                      <p> PRICE:</p>
                      <p> - yearly price 9 EUR/month</p>
                      <p> FUNCTIONS:</p>
                      <p> - Care about your house</p>
                    </div>
                  </CCol>
                  <CCol>
                    <div className="p-3">
                      <CFormCheck
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        label="VIP MEMBERSHIP"
                        onChange={handleVIPMembership}
                      />
                      <p> PRICE:</p>
                      <p> - yearly price 35 EUR/month</p>
                      <p> FUNCTIONS:</p>
                      <p> - Care about your house</p>
                    </div>
                  </CCol>
                </CRow>
              </CContainer>
            </CCol>
          </CCardBody>
        </CCard>
      </div>
    </div>
  )
}

export default WidgetsReminderMembership
